






























































































































































import { ConfirmModal, OnClickOutside } from '@/app/components';
import { useFilters } from '@/app/composable';
import { AssetTypeIcon } from '@/modules/asset/components';
import { AssetType, AssetTypeId } from '@/modules/asset/constants';
import { PencilAltIcon, TrashIcon, DotsVerticalIcon } from '@vue-hero-icons/outline';
import { CalendarIcon, InformationCircleIcon } from '@vue-hero-icons/solid';
import { PropType, Ref, defineComponent, ref, computed } from '@vue/composition-api';
import { RetrievalAccessibility, RetrievalStatus } from '../constants';
import { RetrievalQuery } from '../interfaces';

export default defineComponent({
    name: 'RetrievalQueryCard',
    props: {
        retrievalQuery: {
            type: Object as PropType<RetrievalQuery>,
            required: true,
        },
    },
    components: {
        CalendarIcon,
        TrashIcon,
        PencilAltIcon,
        ConfirmModal,
        AssetTypeIcon,
        InformationCircleIcon,
        OnClickOutside,
        DotsVerticalIcon,
    },
    setup(props) {
        const { formatDateAs } = useFilters();
        const showDeleteModal: Ref<boolean> = ref<boolean>(false);

        const assetType = (typeId: number) => {
            switch (typeId) {
                case AssetTypeId.Model:
                    return AssetType.Model;
                case AssetTypeId.Result:
                    return AssetType.Result;
                default:
                    return AssetType.Dataset;
            }
        };

        const retrievalQueryStatus = computed(() => {
            const baseStatusText = `Asset${
                props.retrievalQuery.assets && props.retrievalQuery.assets.length === 1 ? '' : 's'
            }`;

            let text = '';
            let extraClasses = '';
            let tooltip = '';
            const status = props.retrievalQuery.status;

            if (status === RetrievalStatus.Available) {
                text = `${baseStatusText} Available`;
                extraClasses = 'bg-green-700';
                tooltip = 'The retrieval request is finalised and ready to retrieve data';
            } else if (status === RetrievalStatus.Unavailable) {
                text = `${baseStatusText} Unavailable`;
                extraClasses = 'bg-yellow-600';
                tooltip =
                    'The applicable access policies in one of the datasets have changed so the access to this retrieval request has been revoked.';
            } else if (status === RetrievalStatus.Deprecated) {
                text = `${baseStatusText} Deleted`;
                extraClasses = 'bg-red-700';
                tooltip =
                    'One of the datasets has been deleted so the access to this retrieval request has been revoked.';
            } else {
                text = 'Configuration';
                extraClasses = 'bg-neutral-600';
            }

            return {
                text,
                extraClasses,
                tooltip,
            };
        });

        const isOptionsMenuOpen = ref<boolean>(false);

        return {
            RetrievalStatus,
            RetrievalAccessibility,
            showDeleteModal,
            formatDateAs,
            assetType,
            retrievalQueryStatus,
            isOptionsMenuOpen,
        };
    },
});
